// extracted by mini-css-extract-plugin
export default {"logo":"SidebarBrandLogo_logo__4qkUY","wordmark":"SidebarBrandLogo_wordmark__xs4IK","logoOnBrandBar":"SidebarBrandLogo_logoOnBrandBar__Eoi-f"};